import { Activity, Bell, Check, MessageSquare, Settings } from 'lucide-react';

const AnimatedLogo = () => {
      return (
            <div className="relative w-full h-64 md:h-96">
                  <div className="absolute inset-0 flex items-center justify-center">
                        <div className="relative w-32 h-32 md:w-40 md:h-40">
                              {/* Main circle */}
                              <div className="absolute inset-0 rounded-full bg-kiwilog animate-pulse" />

                              {/* Rotating orbit */}
                              <div className="absolute inset-0 animate-spin duration-[10s]">
                                    {/* Orbital icons */}
                                    <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-16 md:-translate-y-20 transform">
                                          <div className="bg-white dark:bg-gray-800 p-2 rounded-full shadow-lg animate-bounce">
                                                <Bell size={20} className="text-kiwilog" />
                                          </div>
                                    </div>

                                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-16 md:translate-y-20 transform">
                                          <div className="bg-white dark:bg-gray-800 p-2 rounded-full shadow-lg animate-bounce animation-delay-200">
                                                <Check size={20} className="text-kiwilog" />
                                          </div>
                                    </div>

                                    <div className="absolute left-0 top-1/2 -translate-x-16 md:-translate-x-20 -translate-y-1/2 transform">
                                          <div className="bg-white dark:bg-gray-800 p-2 rounded-full shadow-lg animate-bounce animation-delay-400">
                                                <Activity size={20} className="text-kiwilog" />
                                          </div>
                                    </div>

                                    <div className="absolute right-0 top-1/2 translate-x-16 md:translate-x-20 -translate-y-1/2 transform">
                                          <div className="bg-white dark:bg-gray-800 p-2 rounded-full shadow-lg animate-bounce animation-delay-600">
                                                <MessageSquare size={20} className="text-kiwilog" />
                                          </div>
                                    </div>
                              </div>

                              {/* Center icon */}
                              <div className="absolute inset-0 flex items-center justify-center">
                                    <div className="bg-white dark:bg-gray-800 p-4 rounded-full shadow-lg z-10">
                                          <Settings size={30} className="text-kiwilog animate-pulse" />
                                    </div>
                              </div>
                        </div>
                  </div>

                  {/* Floating elements */}
                  <div className="absolute top-1/4 left-1/4 w-20 h-20 bg-primary-100 rounded-full opacity-20 animate-float" />
                  <div className="absolute bottom-1/4 right-1/4 w-16 h-16 bg-primary-200 rounded-full opacity-30 animate-float animation-delay-500" />
                  <div className="absolute top-1/2 right-1/5 w-12 h-12 bg-primary-300 rounded-full opacity-20 animate-float animation-delay-1000" />
                  <div className="absolute bottom-1/3 left-1/3 w-24 h-24 bg-primary-50 rounded-full opacity-10 animate-float animation-delay-1500" />
            </div>
      );
};

export default AnimatedLogo;